<template>
    <div
            class="flex flex-col content-center justify-center text-center w-full bg-white rounded p-4"
          >
            <div class="flex flex-row">
              <div class="flex flex-col w-full mr-2">
                <div class="flex flex-row">
                  <label class="text-md text-grey-700 mb-2">
                    {{ $t('frontend_groovemail_contacts_step5_comingsoon') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
</template>
<script>

import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig.js';

import {
  required,
  minLength,
  maxLength,
  email
} from 'vuelidate/lib/validators';
export default {
  name: 'step5',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
    };
  },
  validations: {
    localModel: {
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      var isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  }
};
</script>

